export const cardBlocking = {
    /** Card is blocked if value is true and state of card is either locked or temporary blocked */
    unblockingBox: false,
};
